import React, { useState, useEffect } from "react";
import "./Styles/ContactSec.css";
import { motion, useViewportScroll } from "framer-motion";

function ContactSec() {
  // -- UX Animation --
  const vHeight = window.innerHeight;
  const { scrollY } = useViewportScroll();
  const [scrollValue, setScrollValue] = useState(0);

  useEffect(() => {
    scrollY.onChange((e) => {
      setScrollValue(scrollY.get());
    });
  }, [scrollY]);

  return (
    <div className="contactSec">
      <motion.h1
        animate={{
          opacity: scrollValue > vHeight * 2.2 ? 1 : 0,
          y: scrollValue > vHeight * 2.2 ? 0 : +50,
          transition: { type: "tween", duration: 0.8 },
        }}
      >
        Seeking for a discussion?
      </motion.h1>
      <motion.h3
        animate={{
          opacity: scrollValue > vHeight * 2.2 ? 1 : 0,
          y: scrollValue > vHeight * 2.2 ? 0 : +50,
          transition: { type: "tween", delay: 0.3, duration: 0.8 },
        }}
      >
        I'm just a mail away!
      </motion.h3>
      <motion.div
        animate={{
          opacity: scrollValue > vHeight * 2.2 ? 1 : 0,
          y: scrollValue > vHeight * 2.2 ? 0 : +50,
          transition: { type: "tween", delay: 0.6, duration: 0.8 },
        }}
        className="contactSec__btn--container"
      >
        <a
          className="contactSec__btn "
          href="mailto:sk.azharuddin@outlook.in?subject=Hi from Web&body=Hello Azhar, "
        >
          Say Hi!
        </a>
      </motion.div>
      <motion.div
        animate={{
          opacity: scrollValue > vHeight * 2.2 ? 1 : 0,
          y: scrollValue > vHeight * 2.2 ? 0 : +50,
          transition: { type: "tween", delay: 0.9, duration: 0.8 },
        }}
        className="contactSec__social"
      >
        <a
          href="https://www.instagram.com/hey.azhar/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Instagram
        </a>
        <a
          href="https://www.linkedin.com/in/sk-azharuddin-3aaa7b192/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Linked In
        </a>
        <a
          href="https://github.com/HeyAzhar"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>
      </motion.div>
    </div>
  );
}

export default ContactSec;
